import React from 'react';

const AchievementBadges = ({ achievements, language }) => {
  const badges = [
    {
      id: 'first_study',
      icon: '🎯',
      name: language === 'tr' ? 'İlk Adım' : 'First Step',
      description: language === 'tr' ? 'İlk çalışma planını tamamladın!' : 'Completed first study plan!',
      unlocked: achievements?.first_study || false
    },
    {
      id: 'week_streak',
      icon: '🔥',
      name: language === 'tr' ? 'Kararlısın!' : 'On Fire!',
      description: language === 'tr' ? '7 gün üst üste çalıştın' : 'Studied 7 days in a row',
      unlocked: achievements?.week_streak || false
    },
    {
      id: 'perfect_score',
      icon: '⭐',
      name: language === 'tr' ? 'Mükemmel!' : 'Perfect!',
      description: language === 'tr' ? 'Bir testte tam puan aldın' : 'Got perfect score on a test',
      unlocked: achievements?.perfect_score || false
    },
    {
      id: 'fast_learner',
      icon: '⚡',
      name: language === 'tr' ? 'Hızlı Öğrenen' : 'Fast Learner',
      description: language === 'tr' ? '50 soruyu tamamladın' : 'Completed 50 questions',
      unlocked: achievements?.fast_learner || false
    },
    {
      id: 'bookworm',
      icon: '📚',
      name: language === 'tr' ? 'Kitap Kurdu' : 'Bookworm',
      description: language === 'tr' ? '5 kitapçık tamamladın' : 'Completed 5 booklets',
      unlocked: achievements?.bookworm || false
    },
    {
      id: 'rising_star',
      icon: '🌟',
      name: language === 'tr' ? 'Yükselen Yıldız' : 'Rising Star',
      description: language === 'tr' ? 'Başarı oranını %20 artırdın' : 'Improved success rate by 20%',
      unlocked: achievements?.rising_star || false
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        {language === 'tr' ? '🏆 Başarılar' : '🏆 Achievements'}
      </h3>
      
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {badges.map((badge) => (
          <div
            key={badge.id}
            className={`p-4 rounded-lg text-center transition-all ${
              badge.unlocked
                ? 'bg-gradient-to-br from-yellow-100 to-yellow-200 border-2 border-yellow-400'
                : 'bg-gray-100 opacity-50'
            }`}
          >
            <div className="text-4xl mb-2">{badge.icon}</div>
            <div className="text-sm font-semibold text-gray-800 mb-1">
              {badge.name}
            </div>
            <div className="text-xs text-gray-600">
              {badge.description}
            </div>
            {badge.unlocked && (
              <div className="mt-2 text-xs text-yellow-700 font-semibold">
                ✓ {language === 'tr' ? 'Kazanıldı' : 'Unlocked'}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AchievementBadges;
